export enum LOCALSTORAGE_VAR {
  CUSTOM_UID = 'customUid',
  ORIGINAL_UID = 'originalUid',
  LOG_LEVEL = 'logLevel',
  FRAME_NUMBER = 'frameNumber',
  ADDITIONAL_SETTINGS_ENABLED = 'additionalSettingsEnabled',
  SUBSCRIPTION_STATUS_CACHE = 'subscriptionStatusCache',
  RENDER_LIMIT_CACHE = 'renderLimitCache',
  RENDER_LIMIT_LAST_CYLCLE_VALUE_CACHE = 'renderLimitLastCycleValueCache',
  FIRST_TIME_SCROLLED_ANY_FEED = 'firstTimeScrolledAnyFeed',
  AI_PROMPT = 'aiPrompt',
  AI_FRAMES_COUNT = 'aiFramesCount',
  AI_TEMPERATURE = 'aiTemperature',
  AI_THINKING_BUDGET = 'aiThinkingBudget',
  AI_PROVIDER = 'ai_provider',
  AI_OPENAI_MODEL = 'ai_openai_model',
  AI_GEMINI_MODEL = 'ai_gemini_model',
  ADVANCED_SEARCH_GENERATION_MODE = 'advancedSearchGenerationMode',
  ADVANCED_SEARCH_PAIR_PREVIEW_DEBUG_MODE = 'advancedSearchPairPreviewDebugMode',
  ADVANCED_SEARCH_PAIR_IMAGE_MODEL = 'advancedSearchPairImageModel',
  ADVANCED_SEARCH_PLANNER_MODEL = 'advancedSearchPlannerModel',
  ADVANCED_SEARCH_CUSTOM_ASSET_COUNT = 'advancedSearchCustomAssetCount',
  ADVANCED_SEARCH_CUSTOM_SYSTEM_PROMPT = 'advancedSearchCustomSystemPrompt',
  ADVANCED_SEARCH_CUSTOM_PORTRAIT_TEMPERATURE = 'advancedSearchCustomPortraitTemperature',
  ADVANCED_SEARCH_CUSTOM_LANDSCAPE_TEMPERATURE = 'advancedSearchCustomLandscapeTemperature',
}
